import { Box, styled } from '@mui/material';

const PREFIX = 'TSMED-StatisticsPreview';

const Root = styled(Box, {
  name: PREFIX,
  slot: 'Root',
})(() => ({
  display: 'flex',
  borderRadius: 'inherit',
}));

export const StatisticsPreview = () => (
  <Root>
    <img
      style={{ borderRadius: 'inherit', pointerEvents: 'none' }}
      src="/statistics.png"
      alt="Statistics"
      width={195}
      height={145}
    />
  </Root>
);
